import { lazy } from 'react';

const CharityVettingNIPCRoute = lazy(
  () => import(/* webpackChunkName: "CharityVettingNIPC" */ '../components/steps/NIPC-step/NIPC'),
);

export default CharityVettingNIPCRoute;
